import { cn } from "@workspace/web-ui/lib/utils"
import { cva, type VariantProps } from "class-variance-authority";

type ScreenSizeIndicatorProps = VariantProps<typeof sizeVariants> & VariantProps<typeof positionVariants> & { className?: string, productionOnly?: boolean };

const positionVariants = cva("fixed z-50 flex items-center justify-center rounded-full bg-black p-4 font-mono text-lg text-white", {
  defaultVariants: {
    position: "bottom-right",
  },
  variants: {
    position: {
      "top-left": "top-3 left-3",
      "top-right": "top-3 right-3",
      "bottom-left": "bottom-3 left-3",
      "bottom-right": "bottom-3 right-3",
    },
  },
});

const sizeVariants = cva("fixed z-50 flex items-center justify-center rounded-full bg-black p-4 font-mono text-lg text-white", {
  defaultVariants: {
    size: "md",
  },
  variants: {
    size: {
      xs: "h-4 w-4 text-xs",
      sm: "h-4 w-4 text-xs",
      md: "h-8 w-8 text-lg",
      lg: "h-12 w-12 text-2xl",
      xl: "h-16 w-16 text-3xl",
      "2xl": "h-20 w-20 text-4xl",
    },
  },
});

export function ScreenSizeIndicator({ className, position, size, productionOnly = false }: ScreenSizeIndicatorProps) {
  if (productionOnly) {
    return null;
  }

  return (
    <div
      className={cn(
        sizeVariants({ size }),
        positionVariants({ position }),
        className,
      )}
    >
      <div className="hidden sm:block md:hidden">sm</div>
      <div className="hidden md:block lg:hidden">md</div>
      <div className="hidden lg:block xl:hidden">lg</div>
      <div className="hidden xl:block 2xl:hidden">xl</div>
      <div className="hidden 2xl:block">2xl</div>
    </div>
  );
}
